import {Subscription} from 'rxjs';
import {Presenter} from '../../../../../Support/with_presenter';
import {RsvpResponse} from '../../../../../Models/CalendarEvent';
import {Rsvp, RsvpInteractor} from '../../../../../Calendar/RsvpInteractor';

export class RsvpResponseBarPresenter implements Presenter {
    public get ratios(): {yes: number; maybe: number; no: number; unknown: number; total: number} {
        const yes = this.rsvps.filter((rsvp) => rsvp.rsvpResponse === RsvpResponse.Yes).length;
        const maybe = this.rsvps.filter((rsvp) => rsvp.rsvpResponse === RsvpResponse.Maybe).length;
        const no = this.rsvps.filter((rsvp) => rsvp.rsvpResponse === RsvpResponse.No).length;
        const unknown = this.rsvps.filter((rsvp) => rsvp.rsvpResponse === RsvpResponse.Unknown).length;

        return {yes, maybe, no, unknown, total: this.rsvps.length};
    }

    private rsvps: Rsvp[] = [];
    private subscription: Subscription | undefined;

    constructor(private scheduledEventId: number, private date: Date, private rsvpInteractor: RsvpInteractor) {}

    public mount(): void {
        this.subscription = this.rsvpInteractor
            .forScheduledEventOnDate(this.scheduledEventId, this.date)
            .subscribe((rsvps) => {
                this.rsvps = rsvps;
            });
    }

    public unmount(): void {
        this.subscription?.unsubscribe();
    }
}
